import React from 'react'

const ResourceCategory = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 13.25C16.4142 13.25 16.75 13.5858 16.75 14C16.75 14.4142 16.4142 14.75 16 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H16ZM20.75 19C20.75 21.0711 19.0711 22.75 17 22.75H7C4.92893 22.75 3.25 21.0711 3.25 19V5C3.25 2.92893 4.92893 1.25 7 1.25H12.25L20.75 7.625V19ZM4.75 19C4.75 20.2426 5.75736 21.25 7 21.25H17C18.2426 21.25 19.25 20.2426 19.25 19V8.75H15C12.9289 8.75 11.25 7.07107 11.25 5V2.75H7C5.75736 2.75 4.75 3.75736 4.75 5V19ZM12.75 5C12.75 6.24264 13.7574 7.25 15 7.25H17.75L12.75 3.49902V5Z" fill="#5C6671"/>
    </svg>
  )
}

export default ResourceCategory
